import { NavLink } from 'react-router-dom';
import profilepicture from '../images/profilepicture.jpeg';

function Navbar() {
  return (
    <nav className="container">
      <NavLink className="navlink" to="/">
        <div className="logo-container">
          <span><img src={profilepicture} alt="logo" className="img-logo" /></span>
        </div>
      </NavLink>
      <ul className="navlink">
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/"
          >
            Profile
          </NavLink>
        </li>
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/Project"
          >
            Projects
          </NavLink>
        </li>
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/Certification"
          >
            Certifications
          </NavLink>
        </li>
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/Skill"
          >
            Skills & Stack
          </NavLink>
        </li>
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/Recommendation"
          >
            Recommendations
          </NavLink>
        </li>
        <li>
          <NavLink
            className="navlink hvr-underline-from-right"
            style={({ isActive }) => (isActive
              ? { textDecoration: 'underline' }
              : { textDecoration: 'none' })}
            to="/Contact"
          >
            Contact me
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
